<template>
    <div class="tw-grid tw-grid-cols-2">
        <i v-if="loading" class="far fa-spinner"></i>
        <div v-else-if="list.length > 0" v-for="(item, idx) in list" :key="item.id"
            class="tw-flex tw-items-center tw-mb-4 tw-flex-col md:tw-flex-row">
            <!-- uncomment this when completely vue -->
            <!-- <div class="tw-flex  tw-items-center tw-cursor-pointer" @click="goToUserProfile(item)"> -->
            <a class="tw-flex tw-items-center tw-cursor-pointer" :href="`/profile/${item.username}`">
                <img class="tw-rounded-full tw-w-12 tw-h-12 tw-mr-4" :src="item.avatar" :alt="item.name" onerror="this.src='/img/avatar.png'" />
                <p class="secondary-c tw-font-bold">{{ item.name }}</p>
            </a>
            <!-- </div> -->

            <template v-if="profile.id === user.id">
                <template v-if="type === 'following'">
                    <button v-if="item.status === 'accepted'" @click="removeFollower(item, idx)" class="btn btn-remove">
                        <i aria-hidden="true" class="far fa-trash"></i> {{ $t('game.remove_follower') }}
                    </button>
                </template>

                <template v-if="type === 'followers'">
                    <button v-if="item.status === 'pending'" @click="acceptFollower(item, idx)" class="btn btn-pending">
                        <i aria-hidden="true" class="far fa-check"></i> {{ $t('game.accept_follower') }}
                    </button>
                    <button v-if="item.status === 'pending'" @click="removeFollower(item, idx)" class="btn btn-decline">
                        <i aria-hidden="true" class="far fa-trash"></i> {{ $t('game.decline_follower') }}
                    </button>
                    <button v-if="item.status === 'accepted'" @click="removeFollower(item.id, idx)"
                        class="btn btn-unfollow">
                        <i aria-hidden="true" class="far fa-trash"></i> {{ $t('game.unfollow') }}
                    </button>
                </template>
            </template>
        </div>
        <div v-else>
            <p class=" tw-text-gray-400">
                {{ type === 'followers' ? $t('user.no_followers') : $t('user.not_following') }}
            </p>
        </div>
    </div>
</template>

<script>
import Global from '../../mixins/Global';
export default {
    name: 'FollowList',
    props: ['profile', 'type'],
    mixins: [Global],
    data() {
        return {
            list: [],
            loading: true,
        }
    },
    watch: {
        type(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loading = true;
                this.getFollow();
            }
        }
    },
    methods: {
        getFollow() {
            this.loading = true;
            axios.get(`/api/v3/users/${this.profile.id}/follow`).then((response) => {
                this.list = this.type === 'followers' ? response?.data?.followers : response?.data?.following;
                this.loading = false;
            });
        },
        unfollow(follow, index) {
            let that = this;
            axios.delete(`/api/v3/follow/${follow.id}`).then((response) => {
                that.list.splice(index, 1);
            });
        },
        removeFollower(follow, index) {
            let that = this;
            axios.delete(`/api/v3/follow/${follow.id}`).then((response) => {
                that.list.splice(index, 1);
            });
        },
        acceptFollower(follow) {
            axios.patch(`/api/v3/follow/${follow.id}`, { status: 'accepted' }).then((response) => {
                follow.status = 'accepted';
            });
        },
        // uncomment this when completely vue
        // goToUserProfile(item) {
        //     const username = this.getProperty(item, 'username');
        //     const url = `profile/${username}`;
        //     console.log(url);
        //     this.$router.go(url);
        // }
    },
    mounted() {
        this.getFollow();
    }
}
</script>
<style lang="scss" scoped>
.btn {
    @apply tw-flex tw-items-center;
    @apply tw-text-gray-400;

    // @apply tw-py-1 tw-px-2 tw-rounded tw-cursor-pointer tw-border tw-border-gray-100 tw-ml-2;
    i {
        @apply tw-mr-1;
    }

    &:hover {
        @apply tw-text-gray-800;
    }
}
</style>